export const QUERY_PARAMS = {
  // global use
  EMAIL: 'e',
  INTERNAL_REVIEW_STAR: 's',
  PHONE_NUMBER: 'p',
  REDIRECT_LINK: 'r',
  REFERER: 'ref',
  PREVIOUS_ROUTE_PATH: 'prp',
  STEP: 'stp',
  // salon search
  SALON_SEARCH_PLACE_ID: 'p',
  SALON_SEARCH_RADIUS: 'r',
  SALON_SEARCH_SERVICE: 's',
  SALON_SEARCH_DATE: 'd',
  SALON_SEARCH_ONLY_SALON_WITH_DISCOUNT: 'discountOnly',
  SALON_SEARCH_SORT_BY: 'sortBy',
  SELECTED_DATE_TIME: 'sdt',
  SELECTED_SERVICES: 'sse',
  SELECTED_STAFF: 'sst',
  // register
  REGISTER_NAME: 'n',
  REGISTER_SURNAME: 's',
  REGISTER_BIRTHDAY: 'b',
  REGISTER_CHALLENGE_ID: 'c',
  // login
  LOGIN_CHALLENGE_ID: 'c',
  ENCODED_PASSWORD_TO_UPDATE: 'eptu',
  // google redirect
  RWG_TOKEN: 'rwg_token',
};
